import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { Button, Badge } from 'react-bootstrap';
import { ClientsFetchAPI } from '../../../api/Clients';
import LoadingAlert from '../../Alerts/LoadingAlert';
import ErrorAlert from '../../Alerts/ErrorAlert';
import Maps from '../../../utils/Maps';
import ModalCreateAddressClient from './ModalCreateAddress';
import ModalViewLocation from './ModalViewLocation';
import { getDireccionMasCercana } from '../../../utils/AddressLocation';



function ModalAddressClient({ client_id, addressClient, getAddressClientNow, addressNowLocation, setAddressNowLocation, coordinates }) {
    const [showModalAddess, setShowModalAddress] = useState(false);
    const [modalcreateAddressClient, setModalcreateAddressClient] = useState(false);
    const [statusLanguage, setStatusLanguage] = useState(0)

    let token = localStorage.getItem("x-access-machine-token")
    const [languages, setLanguages] = useState([])


    //delete address client
    const deleteClientAddress = async (address_id) => {

        console.log(address_id);
        try {

            const response = await ClientsFetchAPI.deleteAddressClient(address_id, token);
            ErrorAlert("Exito", "Direccion eliminada correctamente", "success")

            if (addressNowLocation.id === address_id) {
                localStorage.removeItem("addressNowLocation")
                setAddressNowLocation(null)
            }
            getAddressClientNow()
        } catch (error) {
            ErrorAlert("", error.message, "error")
        }
    }

    const handleSelectAddress = (address) => {
        localStorage.setItem("addressNowLocation", JSON.stringify(address))
        setAddressNowLocation(address)
        setShowModalAddress(false)
    }



    {/*view languages*/ }
    const viewAddress = () => {

        const listItems = addressClient.map((address, index) => (
            <>
                
                <div className='col-12 col-md-12 bg-white p-2 border rounded-2 m-1' >
                    {/* Card */}
                    <label className="card-restaurant">


                        <span className="plan-details">

                            <div className="d-flex justify-content-start">
                                <div className='m-2'>
                                    <span className="plan-type" translate='no'><i class="uil uil-map-marker"></i> Direccion: {address.name}  <br></br>  
                                    <i class="uil uil-house-user"></i> Apto/casa: {address.house_num} <br></br>
                                    <i class="uil uil-phone"></i> Telefono de contacto: {address.phone}
                                    </span>
                                    <p className="plan-description" translate='no'>Referencia de localizacion: {address.additional_info}</p>
                                    <div className='d-flex justify-content-center align-items-center'>
                                        <ModalViewLocation address={{ lat: address.lat, lng: address.lng }}></ModalViewLocation>
                                        <Badge className='p-2 m-1' onClick={() => deleteClientAddress(address.id)}  bg="danger" text="light">
                                            <i class="uil uil-trash-alt"> Eliminar</i>
                                        </Badge>
                                        <Badge className='p-2 m-1' onClick={() => handleSelectAddress(address)} bg="success" text="white">
                                           <i class="uil uil-check"> Seleccionar direccion</i>
                                        </Badge>
                                    </div>
                                </div>
                            </div>
                        </span>
                    </label>
                </div >
            </>
        ));
        return (listItems)
    }

    const handlerLocation = () => {
        let direction = getDireccionMasCercana(addressClient, coordinates)
        const masCercana = direction.find(addr => addr.closest);
        console.log("Direccion mas cercana: ", masCercana);

        if (masCercana !== undefined && masCercana !== null) {
            setAddressNowLocation(masCercana)
            localStorage.setItem("addressNowLocation", JSON.stringify(masCercana))
            setShowModalAddress(false)
            ErrorAlert("Exito", "Estas en " + masCercana.name, "success")
        } else {
            setModalcreateAddressClient(true)
        }

    }

    useEffect(() => {

    }, []);
    return (
        <>


            <div class="row d-flex justify-content-between g-0" >
                <div class="col-12 col-md-12 bg-light border-start border-bottom border-white border-3" >
                    <div class="p-2 fw-bold"> <i class="uil uil-map-marker"></i>Direccion de destino:
                    </div>
                    <div class="p-2">{addressNowLocation !== null ? <>
                        <div className='col-12 col-md-12 bg-white p-2' >
                            {/* Card */}
                            <div className="card-restaurant">
                                <span className="plan-details">
                                    <div className="d-flex justify-content-start">
                                        <div className='m-2'>

                                            <span className="plan-type" translate='no'><i class="uil uil-map-marker"></i> Direccion: {addressNowLocation.name}  <br></br>  <i class="uil uil-house-user"></i> Apto/casa: {addressNowLocation.house_num}</span>
                                            <p className="plan-description" translate='no'>Referencia de localizacion: {addressNowLocation.additional_info}</p>

                                            <div className='d-flex justify-content-between align-items-center'>
                                                {addressNowLocation !== null ? <ModalViewLocation address={{ lat: addressNowLocation.lat, lng: addressNowLocation.lng }}></ModalViewLocation> : <></>}

                                                <Badge className='p-2 m-1' onClick={() => (setShowModalAddress(true), getAddressClientNow())} bg="warning" text="dark">
                                                    <i class="uil uil-edit"> Cambiar direccion</i>
                                                </Badge>
                                            </div>


                                        </div>
                                    </div>
                                </span>
                            </div>

                        </div ></> : <>  <div className='col-12 col-md-12 bg-white p-2 ' onClick={() => (setShowModalAddress(true), getAddressClientNow())} >
                            {/* Card */}
                            <label className="card-restaurant">
                                <span className="plan-details">

                                    <div className="">
                                        <div className='m-2'>
                                            <div className="d-flex justify-content-center align-items-center"><i class="uil uil-location-pin-alt" style={{ fontSize: "2.5rem" }}></i> </div>
                                            <div className="d-flex justify-content-center align-items-center">
                                                <h1 class="badge bg-light text-secondary text-center">No tienes direccion seleccionada <br></br> Seleccionar una aqui</h1>
                                            </div>
                                        </div>
                                    </div>
                                </span>
                            </label>

                        </div ></>}</div>
                </div>
            </div>


            <Modal
                centered
                className='bg-blur-sp'
                size="xl"
                show={showModalAddess}
                onHide={() => setShowModalAddress(false)}>
                <Modal.Body   >

                    <section className=' rounded-4' >

                        <div className=' scale-up-top mt-5'>
                            <h2 className=' text-center'>
                                <i class="uil uil-map-marker"></i>  Elige una direccion de destino:


                            </h2>


                            <div className=' d-flex justify-content-between w-100'>


                                <button className='btn btn-outline-secondary rounded-pill   p-0 border-0' onClick={() => handlerLocation()}>
                                    <span className='d-flex align-items-center fw-bold px-3 py-1'> <i class="uil uil-location-pin-alt"> Ubicacion actual</i>  </span>
                                </button>

                                <button className='btn btn-outline-secondary rounded-pill   p-0 border-0' onClick={() => setModalcreateAddressClient(true)}>
                                    <span className='d-flex align-items-center fw-bold px-3 py-1'> <i class="uil uil-book-medical"> Crear direccion</i>  </span>
                                </button>
                            </div>

                            <ModalCreateAddressClient modalcreateAddressClient={modalcreateAddressClient} setModalcreateAddressClient={setModalcreateAddressClient} getAddressClientNow={getAddressClientNow} client_id={client_id}></ModalCreateAddressClient>

                            <div className='container row justify-item-center'>
                                {addressClient.length > 0 ? <>
                                    {viewAddress()}
                                </> : <>
                                    <div className='col-12 col-md-12 bg-white p-2 d-flex justify-content-center align-items-center border border-2 border-light-subtle rounded-3' onClick={() => setModalcreateAddressClient(true)} >
                                        {/* Card */}
                                        <label className="card-restaurant ">
                                            <span className="plan-details">

                                                <div className="">
                                                    <div className='m-2'>
                                                        <div className="d-flex justify-content-center align-items-center"><i class="uil uil-location-pin-alt" style={{ fontSize: "2.5rem" }}></i> </div>
                                                        <div className="d-flex justify-content-center align-items-center">
                                                            <h1 class="badge bg-light text-secondary text-center">No tienes direcciones creadas <br></br> Crea una aqui</h1>
                                                        </div>
                                                    </div>
                                                </div>
                                            </span>
                                        </label>

                                    </div >
                                </>}

                            </div>

                        </div>
                        <div className='text-muted text-center'>
                            <i className="uil uil-info-circle me-2"></i>
                            Selecciona una direccion. ¡Gracias!
                        </div>
                    </section>

                    
                     <div className='d-block mt-lg-1 mt-0'>
                        <div className='d-flex justify-content-end mt-2'>
                            <button className='btn bg-danger-subtle text-danger  border-0 fw-bold '
                                onClick={() => (setShowModalAddress(false))}
                            >
                               <i class="uil uil-times-circle"></i>  Cerrar
                            </button>
                        </div>
                    </div>
                </Modal.Body>



            </Modal>
        </>
    )
}

export default ModalAddressClient